var map = {
	"./connect.png": "657e",
	"./css/global.css": "aede",
	"./hangbag_menu.png": "d1ea",
	"./home_banner.jpg": "8466",
	"./icon_facebook.png": "c630",
	"./icon_in.jpg": "747b",
	"./icon_ins.png": "ccc4",
	"./icon_locate.png": "2ce9",
	"./icon_package1.png": "1f25",
	"./icon_package2.png": "968c",
	"./icon_package3.png": "dc62",
	"./icon_package4.png": "0962",
	"./icon_package5.png": "5001",
	"./icon_package6.png": "60fc",
	"./icon_process1.png": "2393",
	"./icon_process2.png": "df23",
	"./icon_process3.png": "9aa2",
	"./icon_process4.png": "839b",
	"./icon_twitter.png": "41b8",
	"./icon_youtube.png": "814e",
	"./light_bg.png": "d1c6",
	"./logo.png": "cf05",
	"./search_icon.png": "89e6",
	"./service_calendar.png": "d84c",
	"./service_search.png": "a31d",
	"./service_shake.png": "2137",
	"./status_build.png": "d463",
	"./status_computer.png": "3a2d",
	"./status_network.png": "2eae",
	"./status_praise.png": "f71d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";